export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10024.7f11bdc5.jpg";